var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('geor-header',{attrs:{"legacy-header":_vm.legacyHeader,"legacy-url":_vm.legacyUrl,"logo-url":_vm.logo,"stylesheet":_vm.customStylesheet,"active-app":_vm.activeApp,"config-file":_vm.headerConfigFile,"height":_vm.headerHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }